var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ChbBasicCountryDataFields'),_c('ChbProductsForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }